// extracted by mini-css-extract-plugin
export default {"wrapper":"Pay_wrapper__h+QTM","header":"Pay_header__zTWf7","goBack":"Pay_goBack__-04fM","container":"Pay_container__S7Luf"};